import { cva } from 'cva';
import DefaultLocal from '../../../assets/avatar/default.png';
import Example1 from '../../../assets/avatar/example-1.png';
import Example2 from '../../../assets/avatar/example-2.png';
import Example3 from '../../../assets/avatar/example-3.png';
import Example4 from '../../../assets/avatar/example-4.png';
import Example5 from '../../../assets/avatar/example-5.gif';
import Frame1 from '../../../assets/avatar/frame-1.png';
import Frame2 from '../../../assets/avatar/frame-2.png';
import Frame3 from '../../../assets/avatar/frame-3.png';
import Frame4 from '../../../assets/avatar/frame-4.png';
import Frame5 from '../../../assets/avatar/frame-5.png';
import Frame6 from '../../../assets/avatar/frame-6.png';
import Frame7 from '../../../assets/avatar/frame-7.png';
import Frame8 from '../../../assets/avatar/frame-8.png';
import Frame9 from '../../../assets/avatar/frame-9.png';
export const DefaultAvatar = 'https://stawritecdn.yuewen.com/assets/image/default_avatar.png';
export const DefaultAvatarLocal = DefaultLocal;
export const AvatarMap = {
    Default: DefaultAvatar,
    DefaultLocal,
    Example1,
    Example2,
    Example3,
    Example4,
    Example5,
};
export const FrameMap = {
    Frame1,
    Frame2,
    Frame3,
    Frame4,
    Frame5,
    Frame6,
    Frame7,
    Frame8,
    Frame9,
};
export const getAssetUrl = (currentUrl, assetPath) => {
    const dir = currentUrl.replace(/[^/]*$/, '');
    return new URL(assetPath, dir).href;
};
export const avatarVariant = cva({
    base: [
        '@relative',
        '@rounded-full',
        '@flex',
        '@items-center',
        '@justify-center',
        '@shrink-0',
        'after:@absolute',
        'after:@w-[150%]',
        'after:@h-[150%]',
        'after:@inset-0',
        'after:@bg-contain',
        'after:@bg-no-repeat',
        'after:@bg-[image:var(--frame-url)]',
        'after:@left-1/2',
        'after:@top-1/2',
        'after:@-translate-y-1/2',
        'after:@-translate-x-1/2',
        'after:@z-20',
        'after:@pointer-events-none',
        'before:@absolute',
        'before:@w-full',
        'before:@h-full',
        'before:@rounded-full',
        'before:@border-grey-2_3',
        'before:@z-10',
        'before:@pointer-events-none',
    ],
    variants: {
        size: {
            sm: ['@w-[28px]', '@h-[28px]'],
            md: ['@w-[32px]', '@h-[32px]'],
            lg: ['@w-[40px]', '@h-[40px]'],
        },
        hasImage: {
            true: ['before:@border'],
            false: []
        },
    },
});
export const avatarImageVariant = cva({
    base: [
        '@aspect-square',
        '@outline-0',
        '@rounded-full',
        '@w-full',
        '@h-full',
        '@flex',
        '@items-center',
        '@justify-center',
        '@text-grey-4'
    ],
    variants: {
        hasFrame: {
            true: [],
            false: [],
        },
        canModify: {
            true: ['@bg-grey-2-b', '@border', '@border-grey-2_3'],
            false: [],
        },
    },
});
export const avatarInputClassNames = [
    '@absolute',
    '@opacity-0',
    '@top-0',
    '@left-0',
    '@w-full',
    '@h-full',
    '@cursor-pointer',
];
export const avatarVariantsMap = {
    size: ['sm', 'md', 'lg'],
    src: [
        null,
        AvatarMap.Example1,
        AvatarMap.Example2,
        AvatarMap.Example3,
        AvatarMap.Example4,
        AvatarMap.Example5,
    ],
    frame: [
        null,
        FrameMap.Frame1,
        FrameMap.Frame2,
        FrameMap.Frame3,
        FrameMap.Frame4,
        FrameMap.Frame5,
        FrameMap.Frame6,
        FrameMap.Frame7,
        FrameMap.Frame8,
        FrameMap.Frame9,
    ],
    canModify: [false, true],
};
export const avatarVariantValueNameMap = {
    src: Object.fromEntries(Object.entries(AvatarMap).map(([k, v]) => [v, k])),
    frame: Object.fromEntries(Object.entries(FrameMap).map(([k, v]) => [v, k])),
};
